// ============================================================
// vehicleCatalog.js
//
// Reference dimensions for the vehicle classes used by the bay-approach
// simulation (see utils/vehiclePath.js). Mirrors the same pattern as
// catalog.js/brands.js — a flat data table other code looks values up
// from by key.
//
// These are representative placeholder figures, NOT pulled from a
// specific manufacturer spec sheet. See vehicle-class-reference.md for
// the same table with notes — worth spot-checking against real reference
// vehicles before trusting the numbers in front of a customer.
//
// Fields:
//   length, width       — feet, used for the 2D silhouette and for
//                          collision-check margins (half-width)
//   wheelbase           — feet, not directly used yet but kept for when
//                          turningRadius needs deriving instead of
//                          hand-set (radius ≈ wheelbase / sin(maxSteerAngle))
//   turningRadius        — feet, the ONE number the path solver actually
//                          needs (curb-to-curb, not wall-to-wall)
// ============================================================

export const VEHICLE_CATALOG = {
  car: {
    label: 'Car / sedan',
    length: 15,
    width: 6,
    wheelbase: 9,
    turningRadius: 18,
    // GLB in /public/models/. Tripo's export scale isn't standardized
    // like the hand-built equipment models, so VehiclePath3D fits the
    // model to `length` above by measuring its own bounding box rather
    // than trusting 1 unit = 1 ft. If dimensions above turn out wrong,
    // just edit them here — the 3D model rescales with the number.
    modelPath: 'car.glb',
    // Tripo's export has no baked texture/color, so this tints the raw
    // geometry. Jet black — landed on this after testing colors live in
    // the 3D viewer's color picker (now removed; this is the baked-in
    // result). Lit shading (real light + reflections, no edge-line
    // overlay) is now the only render path for vehicles — see
    // GLBVehicleModel in VehiclePath3D.jsx.
    bodyColor: '#0a0a0a',
    // modelRotation: 0, // degrees — uncomment/adjust if the model faces
    //                    // the wrong way once you see it animate
  },
  suv: {
    label: 'SUV',
    length: 16.5,
    width: 6.5,
    wheelbase: 10,
    turningRadius: 20,
  },
  truck_std_short: {
    label: 'Pickup truck (standard, standard box)',
    length: 19,
    width: 6.5,
    wheelbase: 12,
    turningRadius: 22,
  },
  truck_std_long: {
    label: 'Pickup truck (standard, long box crew cab)',
    length: 22.2,
    width: 6.5,
    wheelbase: 14.5,
    turningRadius: 25,
  },
  truck_dually_short: {
    label: 'Pickup truck (dually, standard box)',
    length: 19,
    width: 8,
    wheelbase: 12,
    turningRadius: 22,
  },
  truck_dually_long: {
    label: 'Pickup truck (dually, long box crew cab)',
    length: 22.2,
    width: 8,
    wheelbase: 14.5,
    turningRadius: 25,
  },
  van: {
    label: 'Van',
    length: 20,
    width: 6.5,
    wheelbase: 13,
    turningRadius: 23,
  },
  bus_short: {
    label: 'Small bus (shuttle, ~20ft)',
    length: 22,
    width: 8,
    wheelbase: 15,
    turningRadius: 28,
  },
  bus_long: {
    label: 'Full-size bus (~40ft)',
    length: 39,
    width: 8.5,
    wheelbase: 23,
    turningRadius: 45,
  },
};

export function getVehicle(key) {
  return VEHICLE_CATALOG[key] || VEHICLE_CATALOG.car;
}
